"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_130)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_130`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.28003 0H27.72V24H-8.28003V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.6673 8.85613C19.8184 8.85613 20.7516 7.923 20.7516 6.77192C20.7516 5.62085 19.8184 4.68771 18.6673 4.68771C17.5163 4.68771 16.5831 5.62085 16.5831 6.77192C16.5831 7.923 17.5163 8.85613 18.6673 8.85613Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0253 6.24561H22.3165V9.36841H15.0253V6.24561Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0253 14.0562V16.1404H16.12C16.7797 16.786 17.6779 17.179 18.6674 17.179C19.6568 17.179 20.5621 16.779 21.2147 16.1404H22.3095V14.0562H15.0253Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0253 8.84912V11.9719C15.0253 14.7649 18.6674 15.614 18.6674 15.614C18.6674 15.614 22.3095 14.7579 22.3095 11.9719V8.84912H15.0253Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.6673 10.5193C17.755 10.5193 17.755 11.3544 16.8427 11.3544C15.9305 11.3544 15.9305 10.5193 15.0182 10.5193V11.979C15.9305 11.979 15.9305 12.814 16.8427 12.814C17.755 12.814 17.755 11.979 18.6673 11.979C19.5796 11.979 19.5796 12.814 20.4919 12.814C21.4042 12.814 21.4042 11.979 22.3164 11.979V10.5193C21.4042 10.5193 21.4042 11.3544 20.4919 11.3544C19.5796 11.3544 19.5796 10.5193 18.6673 10.5193ZM18.6673 7.60001C17.755 7.60001 17.755 8.43509 16.8427 8.43509C15.9305 8.43509 15.9305 7.60001 15.0182 7.60001V9.05966C15.9305 9.05966 15.9305 9.89474 16.8427 9.89474C17.755 9.89474 17.755 9.05966 18.6673 9.05966C19.5796 9.05966 19.5796 9.89474 20.4919 9.89474C21.4042 9.89474 21.4042 9.05966 22.3164 9.05966V7.60001C21.4042 7.60001 21.4042 8.43509 20.4919 8.43509C19.5796 8.43509 19.5796 7.60001 18.6673 7.60001Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.68488 0V1.58596L6.44979 3.74035H9.68488V8.23158H6.44979L9.68488 10.386V11.9789H8.09892L2.94804 8.54035V11.9789H-1.54319V8.54035L-6.69406 11.9789H-8.28003V10.386L-5.04494 8.23158H-8.28003V3.74035H-5.04494L-8.28003 1.58596V0H-6.69406L-1.54319 3.43158V0H2.94804V3.43158L8.09892 0H9.68488Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.82523 0H-0.42038V4.86316H-8.28003V7.10877H-0.42038V11.9789H1.82523V7.10877H9.68488V4.86316H1.82523V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.28003 0V1.05965L-4.25196 3.74035H-2.66599L-8.28003 0ZM9.68488 0V1.05965L5.65681 3.74035H4.07085L9.68488 0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.28003 0V1.05965L-4.25196 3.74035H-2.66599L-8.28003 0ZM9.68488 0V1.05965L5.65681 3.74035H4.07085L9.68488 0ZM-8.28003 11.9789V10.9193L-4.25196 8.23158H-2.66599L-8.28003 11.9789ZM9.68488 11.9789V10.9193L5.65681 8.23158H4.07085L9.68488 11.9789Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_130`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KYFlag };
